(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abino-quality-file-group"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('abino-file-viewer')) {
    class AbinoFileViewer extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.lightbox = this.querySelector('[data-abino-file-lightbox]');
        this.lightboxImage = this.querySelector('[data-abino-file-lightbox-image]');
        this.triggers = this.querySelectorAll('.abino-file-group__lightbox-trigger');
        this.handleKeydown = this.handleKeydown.bind(this);

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.open(trigger));
        });

        this.lightbox?.addEventListener('click', (event) => {
          if (event.target === this.lightbox) this.close();
        });

        window.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        window.removeEventListener('keydown', this.handleKeydown);
      }

      open(trigger) {
        const fileUrl = trigger.dataset.fileUrl;
        if (!fileUrl || !this.lightbox || !this.lightboxImage) return;

        this.activeTrigger = trigger;
        this.lightboxImage.src = fileUrl;
        this.lightboxImage.alt = trigger.dataset.fileAlt || '';
        this.lightboxImage.classList.toggle('abino-file-group__lightbox-image--rotated', trigger.dataset.fileRotated === 'true');
        this.lightbox.hidden = false;
        document.body.classList.add('abino-file-lightbox-open');
        this.lightbox.focus();
      }

      close() {
        if (!this.lightbox || this.lightbox.hidden) return;
        this.lightbox.hidden = true;
        document.body.classList.remove('abino-file-lightbox-open');
        this.lightboxImage.removeAttribute('src');
        this.activeTrigger?.focus();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') this.close();
      }
    }

    customElements.define('abino-file-viewer', AbinoFileViewer);
  }

  } catch(e) { console.error(e); }
})();
})();
